import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryStarDivider from "../../dividers/glossaryScreen/GlossaryStarDivider";
import GlossaryTermWordText from "../../texts/glossaryScreen/GlossaryTermWordText";
import GlossaryTermDefinitionText from "../../texts/glossaryScreen/GlossaryTermDefinitionText";
import {useState} from "react";
import {useResizeListener} from "../../../listeners/SystemResizeListener";
import GlossaryDetailedScreen from "../../../screens/glossary/GlossaryDetailedScreen";
import {kSystemIcons} from "../../../constants/icons";

export default function GlossaryTermItem({term, isFirst, isLast, highlight, search}) {
    // Used in GlossaryLettersList to display one single letter

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsModalOpen(false))

    // BUILD
    if (isNullOrUndefined(term))
        return null
    return (
        <div className={`w-full flex flex-col ${isFirst ? "pt-[4px]" : ""} ${isLast ? "pb-[14px]" : ""}`}>
            {/** MODAL */}
            <GlossaryDetailedScreen
                open={isModalOpen}
                handleClose={processModalClosing}
                term={term} />
            {/** CONTENT */}
            {!isFirst && <GlossaryStarDivider />}
            <div className={"mt-[10px] px-[24px] cursor-pointer w-full grid grid-cols-[minmax(120px,2fr)_minmax(240px,6fr)_minmax(100px,120px)] gap-[16px] items-center"}
                onClick={processModalOpening}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <GlossaryTermWordText
                    word={term.word}
                    search={search}
                    highlight={highlight} />
                <GlossaryTermDefinitionText
                    definition={term.definition}
                    search={search}
                    highlight={highlight} />

                {/*<div className="relative group flex justify-end">*/}
                {/*    <div className={"cursor-pointer text-backgroundLight5 flex space-x-[6px] justify-center items-center rounded-[8px] bg-greenStar hover:bg-greenStar/90 h-[32px] min-h-[32px] pl-[8px] pr-[10px]"}>*/}
                {/*        <i className="material-icons text-[16px] mt-[1px]">*/}
                {/*            {kSystemIcons.eye}*/}
                {/*        </i>*/}
                {/*        <span className={"text-[14px] font-medium whitespace-nowrap"}>*/}
                {/*            {"Voir détail"}*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*</div>*/}



                <div className={"flex justify-end shrink-0"}>
                    <div className={`h-[32px] min-h-[32px] flex space-x-[6px] justify-center items-center ${isHovered ? "bg-primaryDark1" : "bg-primary"}  rounded-[12px] pl-[8px] pr-[10px]`}>
                        <i className="material-icons text-[16px] mt-[1px]">
                            {kSystemIcons.eye}
                        </i>
                        <span className={"text-[14px] font-medium whitespace-nowrap"}>
                            {"Voir détail"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}